<template>
  <div id="app">
    <app-header></app-header>
    <div class="app-header-wrap"></div>
    <router-view></router-view>
    <app-footer></app-footer>
    <el-dialog class="contract dialog" top="70px" :visible="contract.show" :before-close="closeContract"
               :close-on-click-modal="false">
      <h4 slot="title" class="dialog__title">{{contract.title}}</h4>
      <div class="contract__dialog-body" v-html="contract.content"></div>
      <div slot="footer" class="dialog__footer">
        <button class="dialog__footer__confirm-btn" @click="closeContract">确定</button>
      </div>
    </el-dialog>
    <el-dialog class="success-modal" top="23%" :visible="successModal.show" :before-close="closeSuccessMessage"
               :close-on-click-modal="false" @close="closeReload">
      <div class="success-modal__text">{{successModal.content}}</div>
    </el-dialog>
    <el-dialog class="fail-modal" top="23%" :visible="failModal.show" :before-close="closeFailMessage"
               :close-on-click-modal="false">
      <div class="fail-modal__text">{{failModal.content}}</div>
    </el-dialog>
   <!-- <template>
      <el-button
        type="primary"
        @click="openFullScreen"
        v-loading.fullscreen.lock="fullscreenLoading">
        指令方式
      </el-button>
    </template>-->

  </div>
</template>

<script>
import _ from 'lodash';
import Cookie from 'js-cookie';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as types from './vuex/types';
import AppHeader from './components/common/Header.vue';
import AppFooter from './components/common/Footer.vue';
import { Loading } from 'element-ui';
export default {
  //    name: 'app',
  data () {
    return {
      fullscreenLoading: false

    };
  },
  components: {
    AppHeader,
    AppFooter
  },
  computed: {
    ...mapGetters({
      contract: types.GET_CONTRACT,
      successModal: types.GET_SUCCESS_MESSAGE,
      failModal: types.GET_FAIL_MESSAGE
    })
  },
  methods: {
    openFullScreen () {
      Loading.service({ fullscreen: true });
      this.fullscreenLoading = true;
    },
    ...mapActions({
      getIndexInfo: types.GET_INDEX_INFO,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    ...mapMutations({
      setRegisterContract: types.SET_CONTRACT_STATE,
      setUserData: types.SET_USER
    }),
    closeSuccessMessage () {
      this.setSuccessMessage({ show: false });
    },
    closeFailMessage () {
      this.setFailMessage({ show: false });
    },
    closeContract () {
      // close事件似乎无效？用before-close代替
      this.setRegisterContract({ show: false });
    },
    closeReload () {
      //        关闭弹框刷新页面重新获取数据
      if (this.$route.meta.name === 'realNameAuth') {
        this.$router.go(0);
      }
    }

  },
  created () {
    // 如果需要请求接口自动登录，则可以在app.vue此完成请求；目前设计略简陋
    this.setUserData(
      JSON.parse(
        decodeURIComponent(
          !_.isUndefined(Cookie.get('userData')) ? Cookie.get('userData') : '{}'
        )
      )
    );
  },
  mounted () {
    this.getIndexInfo();
  }
};
</script>

<style lang="scss">
@mixin alertModalStyle {
  .el-dialog {
    margin-bottom: 0;
    width: 467px;
    //height: 223px;
  }

  .el-dialog__header {
    @include resetBFC;
    padding: 0 20px;

    .el-dialog__headerbtn {
      position: absolute;
      top: 20px;
      right: 20px;
    }
  }

  .el-dialog__body {
    @include clear;
    box-sizing: border-box;
    display: table;
    padding: 80px 20px;
    width: 100%;
    font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
    font-size: 16px;
    text-align: center;

    & > div {
      position: relative;
      box-sizing: border-box;
      -ms-box-sizing: border-box;
      -moz-box-sizing: border-box;
      display: inline-block;
      width: 395px;
      padding-left: 70px;
      word-wrap: break-word;
      word-break: normal;
      line-height: 30px;
      font-size: 16px;
      color: #666;

      &:before {
        position: absolute;
        left: 0px;
        top: 50%;
        transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        content: "";
        float: left;
        display: block;
        margin-right: 20px;
        width: 50px;
        height: 50px;
        background-size: cover;
      }
    }
  }
}

#app {
  height: 100%;
  /*margin-top: 50px;*/
  font-family: "Microsoft YaHei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*overflow-x: hidden;*/

  .app-header-wrap {
    width: 100%;
    height: 50px;
  }
}

.success-modal {
  @include alertModalStyle;
}

.success-modal__text:before {
  background: url("../static/images/icons/success_alert_icon.png");
}

.fail-modal {
  @include alertModalStyle;
}

.fail-modal__text:before {
  background: url("../static/images/icons/failed_alert_icon.png");
}

.el-dialog__header {
  @include resetBFC;

  .el-dialog__headerbtn {
    position: absolute;
    top: 50%;
    right: 20px;
  }
}

.dialog__title {
  font-size: 18px;
  font-weight: 700;
}

.dialog__footer {
  text-align: center;
}

.dialog__footer__confirm-btn {
  border: 0;
  padding: 0 15px;
  min-width: 120px;
  height: 45px;
  border-radius: 3px;
  font-size: 16px;
  color: #fff;
  line-height: 45px;
  text-align: center;
  background: $orange;
  cursor: pointer;

  &:focus,
  &:active,
  &:visited {
    border: 0;
  }
}

.contract__dialog-body {
  overflow: auto;
  height: 430px;
}
.el-button--primary {
    color: #fff;
    background-color: #EB662B;
    border-color: #EB662B;
}
.el-pager li.active {
    border-color: #EB662B;
    background-color: #EB662B;
    color: #fff;
    cursor: default;
}
.loan-table .el-pager li.number.active {
    color: #EB662B;
    border-color: transparent;
    background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// App.vue?34cf8c9e